import { toMM100GetQuote } from '@/components/PowerKitPreSale/components/PreOrder/InfoQuote/utils';
import SuccessDialog from '@/components/PowerKitPreSale/components/PreOrder/successDialog';
import Image from '@/components/UI/Image';
import { EFQueryPcSvg, EFRightLinkSvg } from '@/components/UI/svg/recommend';
import { useGlobal } from '@/utils/useGlobal';
import { Popover } from 'antd';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
const InfoCollection: any = dynamic(() => import('@/components/PowerKitPreSale/components/PreOrder/infocollection'), { ssr: false });

export default function Recommend({ tabData, activityId }: any) {
    const { useLang, useState, Link, useEffect, isMobile, gtm, useRouter } = useGlobal();
    const { t } = useLang('powerkitsrecommend');
    const { locale } = useRouter();
    const [activeTab, setActiveTab] = useState(0);
    const [activeData, setActiveData] = useState(tabData[0]);
    const [scroll, setScroll] = useState('left');
    const [modalData, setModalData] = useState([]);
    const [isCollectInfo, setIsCollectInfo] = useState(false);

    // 是否展示评论成功弹窗
    const [isCommSuccVisible, setCommSuccVisible] = useState(false);

    const onScroll = (e: any) => {
        const sliderEl = document.querySelector('.pre-sale-nav') as HTMLElement;
        if (e.target?.scrollLeft <= 0) {
            return setScroll('left');
        }
        if (e.target?.scrollWidth - e.target?.scrollLeft <= sliderEl?.offsetWidth) {
            return setScroll('right');
        }
        return setScroll('');
    };

    const tabClick = (tab: Record<string, string | any>) => {
        setActiveTab(tab.tabIndex);
        setActiveData(tabData[tab.tabIndex as keyof typeof tabData]);
    };

    const svgClick = (data: any) => {
        setModalData(data.modalData);
    };

    const preOrderNow = () => {
        if (['us', 'ca', 'de', 'fr', 'uk', 'jp'].includes(locale)) {
            window?.fbq && window?.fbq('track', 'Donate');
        }
        if (['au'].includes(locale)) {
            window?.fbq && window?.fbq('track', 'Contact');
        }
        switch (locale) {
            case 'us':
            case 'ca':
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'click_get_a_quote',
                    product_name: 'EcoFlow Power Kits',
                    position: 'introduction',
                    option_name: 'none',
                });
                toMM100GetQuote(locale);
                break;
            case 'de':
            case 'uk':
            case 'fr':
            case 'au':
            case 'kr':
            case 'jp':
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'click_get_a_quote',
                    product_name: 'EcoFlow Power Kits',
                    position: 'introduction',
                    option_name: 'none',
                });
                setIsCollectInfo(true);
                break;
            default:
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'click_pre_order',
                    product_name: 'EcoFlow Power Kits',
                });
        }
    };

    const openCalculatorPage = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_help_me_choose',
            product_name: 'EcoFlow Power Kits',
        });
        window?.fbq && window?.fbq('track', 'CustomizeProduct');
        let calculatorUrl = `/${locale}/calculators/power-kits`;
        if (!location.origin) {
            // ie的一些老版本不兼容
            calculatorUrl = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/${locale}/calculators/power-kits`;
        }
        // 增加name是为了防止点击打开多个calculator/mm100页面
        window.open(calculatorUrl, 'calculators_mm100');
    };

    const collectInfoCb = ({ status }: any) => {
        if (status === 'success') {
            setIsCollectInfo(false);
            setCommSuccVisible(true);
        }
        switch (status) {
            case 'success':
                setIsCollectInfo(false);
                setCommSuccVisible(true);
                break;
            case 'close':
                setIsCollectInfo(false);
                break;
        }
    };

    const closeSuccDialog = () => {
        setCommSuccVisible(false);
    };

    const popContent = (
        <div className="modal-box">
            <div className="modal-content">
                {modalData &&
                    modalData.length &&
                    modalData.map((item: any, index: number) => (
                        <div className="data-item" key={index}>
                            <div className="svg-box">{item.svg}</div>
                            <div className="title">{item.title}</div>
                            <div className="params">{item.params}</div>
                        </div>
                    ))}
            </div>
        </div>
    );

    return (
        <>
            <div className={css.preSaleBox}>
                <div className={`pre-sale-nav pre-sale-nav-${activeTab}`} onScroll={onScroll}>
                    <div className={`cover  ${scroll === 'left' ? 'left' : scroll === 'right' ? 'right' : ''}`}></div>
                    <div className="nav-wrapper">
                        {tabData.map((tab: Record<string, any>) => (
                            <div className={`nav-item ${tab.tabIndex === activeTab ? 'tab-active' : ''}`} key={tab.tabIndex} onClick={() => tabClick(tab)}>
                                {tab.title}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={css.recommendBox}>
                {isCollectInfo && <InfoCollection cbFunc={collectInfoCb} isRecommend={true} activityId={activityId} />}
                {isCommSuccVisible && <SuccessDialog closeSuccDialog={closeSuccDialog} isRecommend={true} />}
                <div className="tab-content">
                    <div className="card-box">
                        {activeData.content.map((item: any, index: number) => (
                            <div className="card-item" key={index}>
                                <div className="card-item__img">
                                    <Image src={item.img} layout="fill" className="fullImgs" />
                                </div>
                                <div className="text-box">
                                    {!item?.linkType && (
                                        <Link href={`/ecoflow-power-kits/series?activeTab=bundles&params=${item.linkParams}`}>
                                            <span className="bundle-title">{item.bundleTitle}</span>
                                        </Link>
                                    )}
                                    {['us'].includes(locale) && item?.linkType === 'popup' && (
                                        <div onClick={() => toMM100GetQuote(locale)}>
                                            <a>
                                                <span className="bundle-title">{item.bundleTitle}</span>
                                            </a>
                                        </div>
                                    )}
                                    <div className="text-title">{item.title}</div>
                                    <div className="sub-box">
                                        <div className="sub-title">{item.subTitle}</div>
                                        <span>
                                            <Popover overlayClassName={css.recommendPopH5} content={popContent} placement="top" trigger="click" title="">
                                                <EFQueryPcSvg width="16px" height="16px" className="query-svg" onClick={() => svgClick(item)} />
                                            </Popover>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Link href="/ecoflow-power-kits/series?activeTab=bundles">
                        <div className="bundle-btn">
                            <div className="btn-text">{t('explore_all_bundles')}</div>
                            <EFRightLinkSvg width="12px" height="12px" className="right-link" />
                        </div>
                    </Link>
                    <div className="buy-box">
                        <div className="buy-title">{t('buy_title')}</div>
                        <div className="btn-group">
                            {locale !== 'sa' && (
                                <div className="common-btn calculator-btn" onClick={() => openCalculatorPage()}>
                                    {t('btn1')}
                                </div>
                            )}
                            <div className="common-btn callback-btn" onClick={preOrderNow}>
                                {t('btn2')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
